/** Projects — `salescrmapi/src/modules/projects` (migration 012). */
import apiClient, { ifMatch } from './axiosClient.js';

const clean = (p = {}) => Object.fromEntries(Object.entries(p).filter(([, v]) => v !== '' && v != null));

export const listProjects = async (params) => (await apiClient.get('/projects', { params: clean(params) })).data;
export const getProject = async (id) => (await apiClient.get(`/projects/${id}`)).data;
export const createProject = async (body) => (await apiClient.post('/projects', body)).data;
export const updateProject = async (id, patch, rowVersion) => (await apiClient.patch(`/projects/${id}`, patch, { headers: ifMatch(rowVersion) })).data;
export const deleteProject = async (id) => { await apiClient.delete(`/projects/${id}`); };
export const addMilestone = async (id, body) => (await apiClient.post(`/projects/${id}/milestones`, body)).data.data;
export const updateMilestone = async (id, mid, patch) => (await apiClient.patch(`/projects/${id}/milestones/${mid}`, patch)).data.data;
export const deleteMilestone = async (id, mid) => (await apiClient.delete(`/projects/${id}/milestones/${mid}`)).data.data;
